import React from 'react';
import { Link, Typography } from '@loomstateorg/shared-frontend';
import getFontSize from '@loomstateorg/shared-frontend/utils/getFontSize';

export interface Title {
  mcTitle: string;
  rightText: string;
  linkText: string;
  linkUrl: string;
  titleFontSize?: string;
}

export interface Props {
  title: Title;
  rightClassName?: string;
  children?: React.ReactNode;
}

const Title: React.FC<Props> = ({ title, rightClassName = 'flex items-end space-x-10' }) => {
  const scale = title.titleFontSize || '1x';

  return (
    <div className="my-24 flex flex-col justify-between gap-16 md:flex-row" data-testid="quick-action-header">
      <div className="text-left uppercase">
        <Typography
          fontFamily="primaryThin"
          className={`text-${getFontSize(16, scale)}`}
          data-testid="quick-action-group-title"
        >
          {title.mcTitle}
        </Typography>
      </div>
      <div className={rightClassName}>
        <Typography fontFamily="primaryThin" className={`text-${getFontSize(12, scale)} pr-5`}>
          {title.rightText}
        </Typography>
        <Link link={title.linkUrl} data-testid="quick-action-group-cta">
          <Typography fontFamily="primaryThin" className={`text-${getFontSize(12, scale)}`} underline>
            {title.linkText}
          </Typography>
        </Link>
      </div>
    </div>
  );
};

export default Title;
